import { LiveEventType } from 'store/pages/loaders/loader-types';

const isLiveProgram = (program: LiveEventType, currentTimeMs = Date.now()) => {
  const start = new Date(program.start_time).getTime();
  const end = new Date(program.end_time).getTime();

  return start <= currentTimeMs && end > currentTimeMs;
};

export default isLiveProgram;
